import { CustomerType } from "@origin-digital/platform-enums";
import {
  IMcAppType,
  NavFlow,
  Tab,
  salesCommonParameters,
} from "../mcApp.types";

// customisation app entry for authenticated move
export const salesCustomisation: IMcAppType = {
  name: "salesCustomisation",
  path: "/customisation",
  parameters: {
    properties: {
      fuel: salesCommonParameters.fuel,
    },
  },
  description: "(Internal) Customisation app entry for authenticated move",
  navFlow: NavFlow.EXTERNAL_AUTH,
  title: "Customise",
  parent: Tab.MORE,

  conditions: {
    intent: "salesCustomisation",
    customerType: CustomerType.kraken,
  },
};
